import type { Form } from 'payments-lib-types';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { FormGroup } from '@/components/form/groups/FormGroup';
import { Input } from '@/components/form/Input';
import { maskCardNumber } from '@/helpers/masks';
import {
  cardNumberLuhnWarning,
  composeValidators,
  validateCardNumber,
} from '@/helpers/validators';
import type { OfUnion } from '@/types/common';
import type { MethodField } from '../helpers';

export const FieldCreditCardNumber: FC<
  OfUnion<MethodField>[Form.MethodFieldType.CreditCardNumber]
> = ({ fieldName, activeThemeMode }) => {
  const { t } = useTranslation('deposits');

  return (
    <FormGroup mode={activeThemeMode} title={t('fields.cardNumber')}>
      <Input
        formatter={maskCardNumber}
        mode={activeThemeMode}
        name={fieldName}
        placeholder={t('fields.cardNumber')}
        validate={composeValidators(validateCardNumber, cardNumberLuhnWarning)}
        validateOn="blur"
      />
    </FormGroup>
  );
};
